//import Dashboard from '@/components/DashboardMenu/Dashboard'
import { RDashboardLayout } from '@/components/reusable_components/layouts'

import MenuRoutes from './MenuRoutes'

export default [
    {
        path: '/', 
        //name: 'dashboard',
        component: RDashboardLayout, 
        children: MenuRoutes
    },
]